<script lang="ts">
  import { gsap } from 'gsap';
  import { createEventDispatcher, onMount } from 'svelte';

  let emit = createEventDispatcher();
  let el: HTMLElement;

  onMount(() => {
    gsap.from(el.children, {
      autoAlpha: 0,
      duration: 1,
      stagger: 0.5,
      ease: 'linear',
    });
  });

  async function complete() {
    await gsap
      .to(el.children, { autoAlpha: 0, duration: 0.6, stagger: 0.1 })
      .then();
    emit('complete');
  }
</script>

<div
  bind:this={el}
  id="intro-component"
  class="px-8 py-12 mx-auto"
  style="max-width: min(800px, 100%);"
>
  <img src="/icon.png" alt="icon" class="mx-auto" style="width: 400px" />
  <h1>สมาคมนักเรียนเก่าเกียมอุดมศึกษาฯ (สมาคมฯ)</h1>
  <p>ขอเชิญชวนทุกท่านร่วมลงชื่อแนบท้ายแถลงการณ์เรียกร้องไปยัง</p>

  <li class="block ml-4 flex justify-start mt-8">
    <div style='min-width: 2rem'>1.</div>
    <p>
      ผู้พิพากษาศาลยุติธรรมทุก ๆ คนให้ช่วยเหลือเพนกวิ้น ต.อ. 77 พร้อมกับนักกิจกรรมที่ถูกดำเนินคดีทางการเมืองอย่างไม่เป็นธรรม
    </p>
  </li>
  <li class="block ml-4 flex justify-start mt-2">
    <div style='min-width: 2rem'>2.</div>
    <p>
      สมาคมนักเรียนเก่าโรงเรียนเตรียมอุดมศึกษาในพระบรมราชูปถัมป์ (สนตอ.)  ให้หันมาสนใจการละเมิดสิทธิของศิษย์เก่าและเรียกร้องให้สนตอ.มีบทบาทในการสร้างบรรยกาศที่ส่งเสริมสังคมประชาธิปไตยทั้งในและนอกโรงเรียนมากยิ่งขึ้น
    </p>
  </li>
  <br />
  <p>
    โดยเราต้องการรายชื่อจำนวน 7,700 เพื่อแสดงให้เห็นว่านักเรียนเตรียมฯ 84 รุ่น ไม่ได้ยืนข้างเดียวกับเผด็จการ แต่ยืนหยัดเคียงข้างมนุษยชน
  </p>
  <br />
  <p>
    แคมเปญนี้มีเวลาให้ลงชื่อถึงแค่ 7 โมงเช้า ของวันที่ 6 พฤษภาคม เนื่องจากต้องรีบรวบรวมเพื่อนำไปยื่นให้ทันต่อการพิจารณาศาลยุติธรรม
  </p>
  <br />
  <p>
    ถึงเรามีเวลาที่น้อย กับเป้าหมายจำนวนคน 7,700 คน แต่เราเชื่อว่าสายสัมพันธ์พี่น้องเตรียมอุดมบันดาลให้เป็นจริงได้แน่นอน
  </p>
  <br />
  <p>
    <a
      href="/testimony.jpg"
      target="_blank"
      class='underline'
      rel="noopener noreferrer">อ่านเนื้อหาของแถลงการณ์ได้ที่นี่</a
    >
  </p>
  <button class="button is-primary mt-5" on:click={complete}>
    ร่วมลงชื่อได้ที่นี่
  </button>
</div>
